import { v4 as uuidv4 } from 'uuid';
import whatshotData from './data/whatshot-publishers.json';

function getWhatshotPublishers() {
    this.whatshotPublishers = whatshotData.publishers;
    this.observed.whatshotPublishers = uuidv4();
}

export default getWhatshotPublishers;
